import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { mergeTailwindClasses } from '@kontentino/ui';

export type MediaPreviewActionsProps = {
  children: ReactNode;
  className?: string;
  side?: 'bottom' | 'top';
};

export const MediaPreviewActions: FC<MediaPreviewActionsProps> = ({
  children,
  className,
  side = 'bottom',
}) => {
  return (
    <div
      className={mergeTailwindClasses(
        clsx(
          'tw-absolute tw-flex tw-overflow-hidden tw-rounded-md tw-opacity-0 tw-transition-all group-hover:tw-opacity-100',
          {
            'tw-bottom-1 tw-right-1': side === 'bottom',
            'tw-right-1 tw-top-1': side === 'top',
          },
        ),
        className,
      )}
    >
      {children}
    </div>
  );
};
